<template>
  <v-app>
    <!-- ランディングページ用AppBar（ログインボタンあり、アカウントアイコンなし） -->
    <!-- TaiTock/Qumowillランディングページでは独自ヒーローがあるためAppBarを非表示 -->
    <v-app-bar
      v-if="!isBrandedPage"
      app
      :class="{
        'dark-gradient': themeStore.isDarkMode,
        'light-gradient': !themeStore.isDarkMode,
        'no-shadow': true,
        'dark-text': themeStore.isDarkMode,
        'light-text': !themeStore.isDarkMode,
        'd-flex': true,
        'align-center': true,
      }"
      :dark="themeStore.isDarkMode"
      :style="themeStore.isDarkMode ? 'background: black;' : 'background: green;'"
      height="64"
      style="position: fixed; top: 0; z-index: 1100"
    >
      <v-app-bar-title>
        <router-link
          to="/"
          class="d-flex align-center"
          style="text-decoration: none; color: inherit"
        >
          <img
            src="/Poranos_logo.png"
            alt="Poranos Logo"
            class="logo"
          />
        </router-link>
      </v-app-bar-title>
      <v-spacer></v-spacer>

      <!-- 公開サイトへのリンク（VitePress。SPA 外なので通常リンク）。狭幅ではフッターから到達する -->
      <v-btn
        variant="text"
        color="white"
        class="d-none d-md-flex"
        href="/docs/"
      >
        ドキュメント
      </v-btn>
      <v-btn
        variant="text"
        color="white"
        class="d-none d-md-flex mr-2"
        href="/blog/"
      >
        ブログ
      </v-btn>

      <!-- テーマ切り替えボタン -->
      <v-btn
        icon
        variant="text"
        class="mr-2"
        @click="themeStore.toggleTheme"
      >
        <v-icon>{{ themeStore.isDarkMode ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
      </v-btn>

      <!-- ログインボタン -->
      <v-btn
        color="white"
        variant="outlined"
        class="mr-3"
        @click="goToLogin"
      >
        ログイン
      </v-btn>
    </v-app-bar>

    <v-main :class="isDarkMode ? 'dark-main' : 'light-main'">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useTheme } from "vuetify";
import { useThemeStore } from "@/stores/themeStore";
import { useRouter } from "vue-router";

const theme = useTheme();
const isDarkMode = computed(() => theme.global.name.value === "dark");
const themeStore = useThemeStore();
const router = useRouter();

// TaiTock/Qumowillランディングページかどうかを判定（独自ヒーローがあるためAppBar不要）
const isBrandedPage = computed(() => {
  const meta = router.currentRoute.value.meta;
  return meta?.isTaitock === true || meta?.isQumowill === true;
});

const goToLogin = () => {
  router.push("/login");
};
</script>

<style scoped>
.dark-gradient {
  background: linear-gradient(to bottom, #000000, #333333) !important;
}
.light-gradient {
  background: linear-gradient(to bottom, hwb(122 51% 0%), #81c784) !important;
}
.no-shadow {
  box-shadow: none !important;
}
.light-text {
  color: white !important;
  font-weight: bold !important;
}
.dark-text {
  color: white !important;
  font-weight: bold !important;
}
.logo {
  height: 40px;
  max-height: 40px;
  max-width: 120px;
  margin-left: 0;
  object-fit: contain;
}

.dark-main {
  background-color: #121212 !important;
  color: white !important;
}

.light-main {
  background-color: #f5f5f5 !important;
  color: black !important;
}
</style>
